import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import SocialProofBar from './sections/SocialProofBar';
import ProblemSection from './sections/ProblemSection';
import SolutionSection from './sections/SolutionSection';
import HowItWorksSection from './sections/HowItWorksSection';
import BenefitsSection from './sections/BenefitsSection';
import TestimonialSection from './sections/TestimonialSection';
import OfferSection from './sections/OfferSection';
import FAQSection from './sections/FAQSection';
import FinalCTASection from './sections/FinalCTASection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <SocialProofBar />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <BenefitsSection />
      <TestimonialSection />
      <OfferSection />
      <FAQSection />
      <FinalCTASection />
    </div>
  );
};

export default LandingPage;